import React from "react";
import { Text, ChipContent, ChipDelete } from "../StyledComponents";
import { BaSeIcon } from "@base/react";

const Chip = ({ onChange, placeholder, id, disabled, fontSize = 12, iconSize = 23 }) => {
  return (
    <ChipContent
      borderColor="#0061C6"
      border="solid 0.5px #0061C6"
      borderRadius="20px"
      width="-webkit-fill-available"
      opacity={disabled ? "0.4" : "1"}
    >
      <Text fontSize={fontSize} color="#0061C6" style={{fontSize, marginRight:'3px'}}>
        {placeholder}
      </Text>
      {onChange && (
        <ChipDelete type="button" onClick={() => onChange(id)}>
          <BaSeIcon
            name={disabled ? "plus-circle" : "times-circle"}
            size={iconSize}
            description="delete"
            color={disabled ? "#0061C6" : "#FF0000"}
          />
        </ChipDelete>
      )}
    </ChipContent>
  );
};

export default Chip;
